import { Blog } from '@commerce/types/blog'
import Image from "next/legacy/image"
import Link from 'next/link'

interface Props {
  blog: Blog
}

const BlogList: React.FC<Props> = ({ blog }) => {
  return (
    <>
      <section className="flex flex-col">
        {blog.articles.map((article, key) => (
          <>
            <Link
              title={article?.seo?.title || article.title}
              href={`/journal/${article.handle}`}
              className="no-underline"
            >
              <article
                key={`${article.id}-${key}`}
                className="flex flex-col mb-4"
              >
                <h2 className="text-h4 text-text-dark pt-12 pb-8 hover:underline">
                  {article.title ?? article?.seo?.title}
                </h2>
                <div className="h-auto w-full relative">
                  <Image
                    src={article.image?.url}
                    width={Number(article.image?.width) || 1080}
                    height={Number(article.image?.height) || 555}
                    alt={article.title ?? article.image?.altText}
                    unoptimized
                  />
                </div>
                <p className="my-4">
                  {article?.excerpt ?? article?.seo?.description}
                </p>
                <div className="flex justify-end hover:underline">
                  Read more
                </div>
              </article>
            </Link>
          </>
        ))}
      </section>
    </>
  )
}

BlogList.displayName = 'BlogList'

export default BlogList
